import produce from "immer";
import Action from "./Action";
import { UserContext } from "../../Models/User/UserContext";
import UserAction from "../../Models/User/UserAction";
import { sessionStorageKey } from "../../Config/Constants";
import defaultState from "./defaultState";
import { UserActionEnum } from "../../Config/UserType";

const UserReducer = (state: UserContext, action: UserAction) => {
  const newState = produce(state, (draft) => {
    switch (action.type) {
      case UserActionEnum.SET_USERINFO:
        const { userGUID, email } = action.payload;
        draft.userGUID = userGUID;
        draft.email = email;
        break;
      case UserActionEnum.RESET:
        draft = defaultState;
        break;
      default:
        throw new Error("Action Type Not Define");
    }
  });

  /* SAVE IN SESSION STORAGE */
  sessionStorage.setItem(sessionStorageKey.USER_STATE, JSON.stringify(newState));
  return newState;
};

export default UserReducer;
